import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=c02bd1d2&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=c02bd1d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02bd1d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c02bd1d2')) {
      api.createRecord('c02bd1d2', component.options)
    } else {
      api.reload('c02bd1d2', component.options)
    }
    module.hot.accept("./NotificationModal.vue?vue&type=template&id=c02bd1d2&scoped=true", function () {
      api.rerender('c02bd1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/Modal/NotificationModal.vue"
export default component.exports